export function getBrowserLang() {
  const stored = localStorage.getItem('lang')
  if (stored === 'zh-CN' || stored === 'en') return stored
  const nav = (navigator.language || navigator.userLanguage || 'zh-CN').toLowerCase()
  return nav.startsWith('zh') ? 'zh-CN' : 'en'
}
